import { ConflitosTagView } from "./view-equipe-conflitos-tag";
import type { ConflitosTagProps } from "./types-equipe-conflitos-tag";

export function ConflitosTag(props: ConflitosTagProps) {
  return <ConflitosTagView {...props} />;
}

export type * from "./types-equipe-conflitos-tag";
